import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Text, Image, StyleSheet, ActivityIndicator } from 'react-native';

import Colors from '../../constants/Colors';

const styles = StyleSheet.create({
  view: {
    backgroundColor: Colors.lightBackground,
    flex: 1,
  },
  header: {
    backgroundColor: Colors.white,
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
    height: 56,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerText: {
    color: Colors.mediumBlue,
    fontSize: 20,
    fontWeight: '500',
  },
  mainContent: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.lightBackground,
    padding: 16,
  },
  image: {
    height: 128,
    width: 128,
    marginBottom: 40,
  },
  text: {
    color: Colors.grayText,
    fontSize: 18,
    lineHeight: 24,
    textAlign: 'center',
  },
});

class NoVisitsPage extends Component {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    this.state = { isLoading: true };
  }

  spinnerTimer = null;

  componentDidMount() {
    this.spinnerTimer = setTimeout(() => {
      this.setState({ isLoading: false });
    }, 2000);
  }

  componentWillUnmount() {
    if (this.spinnerTimer) {
      clearTimeout(this.spinnerTimer);
    }
  }

  capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  render() {
    const { translation, registration } = this.props;
    const { isLoading } = this.state;
    const { user } = registration;
    const labels = {
      findPantry: translation.please_sign_in_or_up,
      visits: translation.fragment_main_bottombar_visits,
    };
    if (user && user.id) {
      labels.findPantry = translation.findPantry;
    }

    return (
      <View style={styles.view}>
        <View style={styles.header}>
          <Text style={styles.headerText}>{this.capitalize(labels.visits)}</Text>
        </View>
        {isLoading ? (
          <View style={styles.mainContent}>
            <ActivityIndicator size="large" color={Colors.mediumBlue} />
          </View>
        ) : (
          <View style={styles.mainContent}>
            <Image source={require('../../assets/images/plentiful_icon_gray.png')} style={styles.image} />
            <Text style={styles.text}>{labels.findPantry}</Text>
          </View>
        )}
      </View>
    );
  }
}

export default NoVisitsPage;
